<template>
  <section id="step0" class="p-content-plan-manual-step">
    <div class="l-container">
      <h2 class="c-title--x-large">
        STEP0 新規コンテンツ作成における参考資料
      </h2>
      <div class="l-rows">
        <p>
          下記のフォーマットをダウンロードしてご活用ください。<br /><a
            :href="downloadUrl"
            class="c-link--underline"
            >記事作成フォーマット
          </a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    keyword: {
      type: String,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    }
  },
  computed: {
    downloadUrl() {
      const organizationId = this.$store.getters['view/organization']
        .organizationId;
      return `${process.env.VUE_APP_CONTENT_PLAN_WRITING_FORMAT_DOWNLOAD_URL}?organization_id=${organizationId}&created_at=${this.createdAt}&keyword=${this.keyword}`;
    }
  }
};
</script>
